import React, { useMemo } from "react";

import usePollQuery from "../../../lib/usePollQuery";
import { receiptQuery } from "./gql";
import * as UI from "./ui";

const TIMEOUT = 10000;
const INTERVAL = 500;

const generatePromoSummary = count => {
  return count > 0 ? ` + ${count} Promo Code Entries` : "";
};

const EntryNumbers = ({ donationId }) => {
  const { data, loading, error, dataAvailable, timedOut } = usePollQuery(receiptQuery, {
    pollInterval: INTERVAL,
    pollTimeout: TIMEOUT,
    testPath: ['receipt', 'ticketRanges'],
    variables: { id: donationId },
  });

  const ticketRanges = useMemo(() => data?.receipt?.ticketRanges || [], [data, dataAvailable]);

  if(loading || error) return null;

  if(ticketRanges.length === 0) {
    return timedOut ? (
      <UI.LoadingEntryNumbers>
        Thanks for your patience. Processing your donation is taking longer than expected. Don’t worry, you’ll receive an email with your entry numbers.
        For more help, please contact us: <a href="mailto:support@tapkat.com">support@tapkat.com</a>
      </UI.LoadingEntryNumbers>
    ) : (
      <UI.LoadingEntryNumbers>
        Thank you for donating. Just a sec while we process your donation...
      </UI.LoadingEntryNumbers>
    );
  }

  return (
    <React.Fragment>
      <UI.EntrySummary>
        {data.receipt.rewardTicketCount} Entries
        {generatePromoSummary(data.receipt.promoCodeTicketCount)}
      </UI.EntrySummary>
      <UI.EntryNumbers>
        <ul>
          { ticketRanges.map(({ min, max }) => (
            <li key={min}>Entry #{ min } - #{ max }</li>
          )) }
        </ul>
      </UI.EntryNumbers>
    </React.Fragment>
  );
};

export default EntryNumbers;
